<div class="contenedor-form" [formGroup]="transportadorGroup">
  <div class="row" *ngIf="transportadores.length > 0">
    <div class="col s12 m12 l6">
      <mat-form-field class="example-full-width">
        <input
          matInput
          placeholder="Transportador"
          aria-label="Transportador"
          [matAutocomplete]="auto"
          formControlName="transportadorCtrl"
        />
        <mat-autocomplete
          #auto="matAutocomplete"
          [displayWith]="displayFn"
          (optionSelected)="buscarServicios($event.option.value)"
        >
          <mat-option
            *ngFor="let transportador of (filteredTransportadores | async)"
            [value]="transportador"
          >
            <span>{{ transportador.Valor }}</span>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>
  </div>
  <div class="row">
      <div class="col s12 m12 l6">
          <h4 *ngIf="sinAsignar.length>0">Servicios Sin Asignar</h4>
          <div *ngFor="let servicio of sinAsignar">
            <mat-card class="example-card" style="overflow:hidden;">
              <mat-card-header>
                <mat-card-title style="margin-left: -20px;"
                  ><span class="bolder">Servicio:</span>
                  {{ servicio.NroServicio }}</mat-card-title
                >
                <mat-card-subtitle style="margin-left: -20px;"><span class="bolder">Fecha Visita:</span>{{servicio.fechaPrestacion}}</mat-card-subtitle>
              </mat-card-header>
              <mat-card-content>
                <p>
                  <span class="bolder">Origen:</span> {{ servicio.DireccionOrigen }}
                </p>
                <p>
                  <span class="bolder">Destino:</span>
                  {{ servicio.DireccionDestino }}
                </p>
              </mat-card-content>
              <mat-card-actions>
                  <button
                    style="float:right;"
                    mat-button
                    (click)="asignarServicio(servicio)"
                  >
                    Asignar
                    <mat-icon>arrow_forward_ios</mat-icon>
                  </button>
                </mat-card-actions>
            </mat-card>
            <mat-divider></mat-divider>
            <br />
          </div>
        </div>
    <div class="col s12 m12 l6">
      <h4 *ngIf="asignados.length>0">Servicios Asignados</h4>
      <div *ngFor="let servicio of asignados">
        <mat-card class="example-card" style="overflow:hidden;">
          <mat-card-header>
            <mat-card-title style="margin-left: -20px;"
              ><span class="bolder">Servicio:</span>
              {{ servicio.NroServicio }}</mat-card-title
            >
            <mat-card-subtitle style="margin-left: -20px;"><span class="bolder">Fecha Visita:</span>{{servicio.fechaPrestacion}}</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <p>
              <span class="bolder">Origen:</span> {{ servicio.DireccionOrigen }}
            </p>
            <p>
              <span class="bolder">Destino:</span>
              {{ servicio.DireccionDestino }}
            </p>
          </mat-card-content>
          <mat-card-actions>
              <button
                style="float:left;"
                mat-button
                (click)="removerServicio(servicio)"
              >
              <mat-icon>arrow_back_ios</mat-icon>
                No asignar

              </button>
          </mat-card-actions>
        </mat-card>
        <mat-divider></mat-divider>
        <br />
      </div>
    </div>
  </div>
</div>
